import {useQuery} from 'admin/lib/apollo'
import {GET_USERS} from 'admin/gql/Users.gql'
import {NumberParam, StringParam, useQueryParams, withDefault} from 'use-query-params'

export default (organisationId, userId = undefined, {includeFilters = true} = {}) => {
  const [filters, setFilters] = useQueryParams({
    q: withDefault(StringParam, ''),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 50),
    sortBy: withDefault(StringParam, 'email'),
    sortDirection: withDefault(StringParam, 'asc'),
    sortLabel: withDefault(StringParam, 'Email')
  })

  const variables = {organisationId, userId, ...(includeFilters ? filters : {})}
  const {data} = useQuery(GET_USERS, {variables})
  const response = data ? data.users : []

  return {
    filters,
    setFilters,
    users: response.collection || [],
    totalCount: response.metadata ? response.metadata.totalCount : 0
  }
}
